import PuzzleData from '../PuzzleData';

import generateShuffledFaces from './generate-shuffled-faces';

const ShuffledFaces = {
  top: generateShuffledFaces('top', false),
  right: generateShuffledFaces('right', false),
  left: generateShuffledFaces('left', false),
};

export default function generateInitialState() {
  const state = [];

  PuzzleData.Cubes.forEach((cube, index) => {
    state.push({});

    for (const face in cube) {
      if (Object.prototype.hasOwnProperty.call(cube, face)) {
        const randomId = ShuffledFaces[face].shift();
        const faceData = PuzzleData.Faces[face][randomId];

        state[index][face] = {
          [randomId]: faceData,
        };
      }
    }
  });

  return state;
}
